<template>
  <div id="feedBackDetail">
    <el-form ref="addPop" class="containerWarp" :inline="false" :model="basinfo" label-position="left" label-width="auto">
      <el-row :gutter="40">
        <el-col :xs="24" :sm="24" :lg="12" class="basinfoStatu basinfoBox">
          <!-- <el-form-item :label="$t('AllDevices.Status')"> -->
          <span class="attr">{{ $t('AllDevices.Status') }}：</span>
          <el-popover v-if="basinfo.status==0||basinfo.status==1" v-model="showPopover" placement="bottom" width="auto" trigger="click" popper-class="basinfoStatuPop">
            <div>
              <div v-for="(item,index) in statusOptions" :key="index" class="statusOption">
                <p v-if="item.key>=basinfo.status&&item.canSelect" class="statuSelect" :class="{'activeStatu':item.isActive}" @click="selectStatu(item.key)">{{ item.label }}</p>
                <div v-if="item.isActive" class="el-icon-success" />
              </div>
              <div slot="footer" class="dialog-footer" style="text-align: center;margin-top:10px;">
                <el-button class="filter-item" type="primary" @click="submitEdit">{{ $t('button.Submit') }}</el-button>
              </div>
            </div>
            <div slot="reference" :class="{'doing':basinfo.status==0||basinfo.status==1,'done':basinfo.status==2,'overTime':basinfo.status==3||basinfo.status==4}">
              {{ basinfo.statusZh }}
            </div>
          </el-popover>
          <div v-else :class="{'doing':basinfo.status==0||basinfo.status==1,'done':basinfo.status==2,'overTime':basinfo.status==3||basinfo.status==4}">
            {{ basinfo.statusZh }}
          </div>
          <!-- </el-form-item> -->
        </el-col>
        <el-col :xs="24" :sm="24" :lg="12" class="basinfoBox">
          <!-- <el-form-item :label="$t('warningPage.CreatedAt')"> -->
          <span class="attr">{{ $t('warningPage.CreatedAt') }}：</span>
          <span class="val">{{ basinfo.creatTimeZh }}</span>
          <!-- <el-input v-model="basinfo.creatTimeZh" :disabled="true" :placeholder="$t('warningPage.CreatedAt')" class="searchInp" /> -->
          <!-- </el-form-item> -->
        </el-col>
        <el-col :xs="24" :sm="24" :lg="12" class="basinfoBox">
          <!-- <el-form-item :label="$t('AllDevices.Type')">
            <el-input v-model="basinfo.typeZh" :disabled="true" :placeholder="$t('AllDevices.Type')" class="searchInp" />
          </el-form-item> -->
          <span class="attr">{{ $t('AllDevices.Type') }}：</span>
          <span class="val">{{ basinfo.typeZh }}</span>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="12" class="basinfoBox">
          <!-- <el-form-item label="关联设备(SN)">
            <el-input v-model="basinfo.sn" :disabled="true" class="searchInp" />
          </el-form-item> -->
          <span class="attr">{{ $t('feedBack.AssociatedDevice') }}：</span>
          <span class="val">
            <!-- sn都是数字（即为Yhub）才跳转，其他不跳转 -->
            <el-link v-if="basinfo.sn&&basinfo.sn.length>3&&/^[0-9]*$/.test(basinfo.sn)" style="font-size: 18px;" type="primary" @click="goToDetailPage">{{ basinfo.sn }}</el-link>
            <span v-else style="font-size: 18px;" type="primary">{{ basinfo.sn }}</span>
          </span>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24" class="basinfoBox">
          <!-- <el-form-item :label="$t('company.remark')">
            <el-input v-model="basinfo.content" :disabled="true" :autosize="{ minRows: 4, maxRows: 8}" :placeholder="$t('company.remark')" style="width: 100%" type="textarea" />
          </el-form-item> -->
          <span class="attr">{{ $t('company.remark') }}：</span>
          <span class="val">{{ basinfo.content }}</span>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="24" class="basinfoBox basinfoImgBox">
          <span class="attr">{{ $t('feedBack.image') }}：</span>
          <div v-if="apiImgList.length>0" class="imgWarp">
            <div v-for="(item,index) in apiImgList" :key="index" class="smallImgBox" @click="clickSmallContentImg(item)">
              <img :src="item" alt="">
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="contentWarp">
      <p class="blockTitleP">{{ $t('feedBack.ComRecord') }}</p>
      <div style="height:calc(100% - 40px);">
        <div v-loading="loading" class="recordWarp">
          <p v-if="recordList.length==0" style="text-align:center;">{{ $t('feedBack.NoComRecord') }}</p>
          <div v-for="(item,index) in recordList" :key="index" class="recordBox" :class="item.type==2?'leftRecordBox':'rightRecordBox'">
            <!-- <div v-for="(item,index) in recordList" :key="index" class="recordBox"> -->
            <!-- 处理人：1客户，2内部人员 -->
            <img v-if="item.type==2" src="@/assets/images/salerIcon.png" alt="">
            <div class="contentAndTime">
              <div>
                <span v-if="item.type==2">{{ $t('feedBack.postsale') }}</span>
                <span v-if="item.type==1">{{ item.createBy }}</span>
                <span>{{ item.createTimeZh }}</span>
              </div>
              <div :class="item.type==1?'leftContent':'rightContent'">
                <p>{{ item.content }}</p>
                <img v-if="item.imgs" :src="item.imgs" alt="" class="contentImg" @click="clickSmallContentImg(item.imgs)">
              </div>
            </div>
            <img v-if="item.type==1" src="@/assets/images/curtomerIcon.png" alt="">
          </div>
        </div>
        <div v-if="basinfo.status<=1" class="btnGroup">
          <el-input v-model.trim="newContent" :placeholder="$t('company.remark')" class="searchInp submitNewContent" clearable>
            <div slot="append" style="cursor: pointer;" @click="submitContent()"> <img src="@/assets/images/icon/send.png" alt=""></div>
          </el-input>
          <!-- 不能输入空白信息 -->
          <div v-if="isShowSpaceWarn" class="spaceWarnPop">
            <p>{{ $t('feedBack.CannotSpaceInfo') }}</p>
          </div>
          <el-upload class="upload-demo" action="#" :on-change="handleChange" :show-file-list="false">
            <el-button type="primary" icon="el-icon-plus" />
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showBigContentImg">
      <img width="100%" :src="bigContentImgUrl" alt="bigContentImgUrl">
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerServiceById, listCustomerServiceDetail, addCustomerServiceDetail, uploadImg, addCustomerService, querySN, updateCustomerServiceStatus } from '@/api/feedBack'
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'

export default {
  name: '',
  components: {

  },
  data() {
    return {
      basinfo: {
        editStatus: null,
        statusZh: null,
        creatTimeZh: null,
        typeZh: null,
        sn: '',
        content: null
      },
      apiImgList: [],
      uploadImgTime: 0, // 文件上传时间
      statusOptions: [ // 状态：0未处理，1处理中，2已处理，3已过期,4作废
        { key: 0, label: i18n.t('feedBack.Untreated') },
        { key: 1, label: i18n.t('feedBack.Processing') },
        { key: 2, label: i18n.t('feedBack.Processed') },
        { key: 3, label: i18n.t('feedBack.expired') },
        { key: 4, label: i18n.t('feedBack.Void') }
      ],
      showPopover: false,
      isView: true,
      loading: true,
      recordList: [],
      newContent: '',
      showBigContentImg: false,
      bigContentImgUrl: '',
      isShowSpaceWarn: false,
      scrollContainer: null
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    typeOptions() { // 反馈类型：1硬件产品问题、2系统后台问题、3APP问题、4QR扫码、5其它
      return [
        { key: 1, label: i18n.t('feedBack.HardwareProblem') },
        { key: 2, label: i18n.t('feedBack.SystemProblem') },
        { key: 3, label: i18n.t('feedBack.APPProblem') },
        { key: 4, label: i18n.t('feedBack.QRProblem') },
        { key: 5, label: i18n.t('feedBack.other') }
      ]
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.statusOptions.forEach(v => {
        switch (v.key) {
          case 0:v.label = i18n.t('feedBack.Untreated'); break
          case 1:v.label = i18n.t('feedBack.Processing'); break
          case 2:v.label = i18n.t('feedBack.Processed'); break
          case 3:v.label = i18n.t('feedBack.expired'); break
          case 4:v.label = i18n.t('feedBack.Void'); break
        }
      })
      this.queryList()// 获取基本信息
      this.queryRecord()// 获取沟通记录
    },
    $route() {
      this.statusOptions.forEach(v => {
        v.canSelect = true
        if (this.$store.state.companyId != 4 && !this.$store.state.isAdmin && (v.key == 1 || v.key == 3)) {
          v.canSelect = false
        }
      })
      this.statusOptions = [...this.statusOptions]
      this.queryList()// 获取基本信息
      this.queryRecord()// 获取沟通记录
    }
  },
  mounted() {
    this.statusOptions.forEach(v => {
      v.canSelect = true
      if (this.$store.state.companyId != 4 && !this.$store.state.isAdmin && (v.key == 1 || v.key == 3)) {
        v.canSelect = false
      }
    })
    this.statusOptions = [...this.statusOptions]
    this.queryList()// 获取基本信息
    this.queryRecord()// 获取沟通记录
  },
  methods: {
    async setScrollBottom() { // 滚动条自动到底部
      this.$nextTick(() => {
        if (this.recordList.length > 0) {
          const el = this.scrollContainer
          el.scrollTop = el.scrollHeight - el.clientHeight
        }
      })
    },
    queryList() { // 获取基本信息
      getCustomerServiceById({ id: this.$route.query.id }).then(res => {
        if (res.resultCode !== 1001 || !res.resultModel) return
        this.basinfo.editStatus = this.basinfo.status = res.resultModel.status
        this.basinfo.sn = res.resultModel.sn
        this.basinfo.mcuId = res.resultModel.mcuId
        this.basinfo.deviceType = res.resultModel.deviceType
        this.basinfo.content = res.resultModel.content
        this.apiImgList = []
        if (res.resultModel.imgs.indexOf(',') > -1) {
          this.apiImgList = res.resultModel.imgs.split(',')
        } else if (res.resultModel.imgs.length > 3) {
          this.apiImgList.push(res.resultModel.imgs)
        }
        this.statusOptions.forEach(v => {
          // console.log(v)
          v.isActive = false
          if (v.key == res.resultModel.status) {
            this.basinfo.statusZh = v.label
            v.isActive = true
          }
        })
        if (res.resultModel.createTime) this.basinfo.creatTimeZh = getDateAndHour(new Date(res.resultModel.createTime).getTime(), 'noSecond')
        this.typeOptions.forEach(v => {
          if (v.key == res.resultModel.type) this.basinfo.typeZh = v.label
        })
      })
    },
    selectStatu(key) { // 基本信息中改状态--选中状态
      this.statusOptions.forEach(v => {
        v.isActive = false
        if (v.key == key) {
          v.isActive = true
          this.basinfo.editStatus = v.key
        }
      })
      this.statusOptions = [...this.statusOptions]
      // console.log('this.statusOptions', this.statusOptions)
    },
    submitEdit() { // 基本信息中改状态--提交
      var param = {
        'id': this.$route.query.id,
        'status': this.basinfo.editStatus
      }
      updateCustomerServiceStatus(param).then(res => {
        if (res.resultCode === 1001) {
          this.showPopover = false
          this.queryList()// 获取基本信息
        }
      })
    },
    queryRecord() { // 获取沟通记录
      this.loading = true
      this.recordList = []
      listCustomerServiceDetail({ id: this.$route.query.id }).then(res => {
        this.loading = false
        if (res.resultCode === 1001) {
          var list = res.resultModel || []
          list.forEach(v => {
            if (v.createTime)v.createTimeZh = getDateAndHour(new Date(v.createTime).getTime(), 'noSecond')
          })
          this.recordList = list
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollContainer = document.querySelector('.recordWarp')
              if (this.recordList.length > 0) this.setScrollBottom()
            }, 100)
          })
        }
      })
    },
    submitContent(img) { // 提交回复
      if (this.newContent.length == 0 && !img) {
        var timer = null
        this.isShowSpaceWarn = true
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.isShowSpaceWarn = false
        }, 2000)
        return
      }
      var param = {
        'cid': this.$route.query.id,
        'content': this.newContent,
        'imgs': '',
        'type': 1
      }
      if (img)param.imgs = img
      if (this.$store.state.companyId == 4 || this.$store.state.isAdmin)param.type = 2
      addCustomerServiceDetail(param).then(res => {
        if (res.resultCode == 1001) {
          this.newContent = ''
          this.queryRecord()// 获取沟通记录
        }
      })
    },
    handleChange(file, fileList) { // 提交图片
      // console.log('/////////', file)
      var houzui = '' // 上传文件的格式
      if (this.uploadImgTime == file.uid) return
      this.uploadImgTime = file.uid
      if (file.name.indexOf('.') > -1) {
        var arr = file.name.split('.')
        houzui = arr[arr.length - 1].toLowerCase()
      }

      if (houzui != 'jpg' && houzui != 'png' && houzui != 'jpeg') {
        this.$message({
          type: 'error',
          message: i18n.t('feedBack.formatWrong') // 格式不对，请上传图片！
        })
        return
      } else if (file.size > 10 * 1024 * 1024) {
        this.$message({
          type: 'error',
          message: i18n.t('feedBack.overSize') // 图片大小不能超过10M，请重试！
        })
        return
      }
      uploadImg(file).then(res => {
        if (res.resultCode == 1001) {
          this.submitContent(res.resultModel)
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedBack.ImgUploadFailed') // '图片上传失败，请重试！'
          })
        }
      })
    },
    clickSmallContentImg(url) { // 点击内容区的小图片
      this.showBigContentImg = true
      this.bigContentImgUrl = url
    },
    goToDetailPage() { // 去YHUB详情页
      var routeData = this.$router.resolve({
        path: '/allDevices/allDeviceDetail',
        query: {
          mcuId: this.basinfo.mcuId,
          deviceType: this.basinfo.deviceType,
          sn: this.basinfo.sn
        }
      })
      window.open(routeData.href, '_self')
    },
    change(e) {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
#feedBackDetail{
  height: 100%;
  .containerWarp{
    padding:20px 20px 10px
  }
  .attr{
    word-break: keep-all;
  }
  .basinfoStatu{
    .doing,.done,.overTime{
      padding: 6px 30px;
      display: inline-block;
      line-height: 14px;
      border-radius: 15px;
      cursor: not-allowed;
    }
    .doing{
      color: #1990fc;
      border: 1px solid #1990fc;
      cursor: pointer;
    }
    .done{
      color: black;
      border: 1px solid black;
    }
    .overTime{
      color: #aaadb4;
      border: 1px solid #aaadb4;
    }
  }
  .basinfoBox{
    margin-bottom: 10px;
    min-height: 28px;
    display: flex;
    align-items: center;
  }
  .statuInp{
    width: calc(100% - 70px);
    margin-right:10px;
  }
  .statuSelect{
    margin-right: 10px;
    width: calc(100% - 140px);
  }
  .basinfoImgBox{
    height: auto;
    align-items: flex-start;
  }
  .imgWarp{
    display: flex;
  }
  .smallImgBox{
    width:100px;
    min-height:100px;
    display: flex;
    align-items: center;
    margin-right: 10px;
    img{
      width:100%;
      cursor: pointer;
    }
  }
  .blockTitleP{
    padding: 20px;
    background: #fff;
  }
  .contentWarp{
    margin-top: 20px;
    height: calc(100% - 170px);
    // padding:20px;
  }
  .recordWarp{
    border: 1px solid #dfe4ed;
    padding: 20px 10px;
    min-height: 60px;
    max-height: calc(100% - 70px);
    background: #fff;
    overflow-y: auto;
    img{
      width: 45px;
      vertical-align: top;
    }
    .contentAndTime {
      display: inline-block;
      margin: 10px;
      .contentImg{
        width:100px;
        cursor: pointer;
      }
    }
    .content,.leftContent,.rightContent{
      position: relative;
      display: inline-block;
      padding: 10px 15px;
      width: auto;
      text-align: left;
      background: #ffffff;
      border: 1px solid #13ce66;
      z-index: 0;
      border-radius: 5px 0 5px 5px;
      margin-top: 5px;
    }
    .leftContent:before {
      border-style: solid;
      border-width: 0px 0 6px 6px;
      border-color: transparent transparent transparent #fff;
      content: "";
      position: absolute;
      top: 9px;
      right: -5px;
      margin-top: -9px;
      display: block;
      width: 0px;
      height: 0px;
      z-index: 0;
    }
    .leftContent:after {
      border-style: solid;
      border-width: 0px 0 7px 7px;
      border-color: transparent transparent transparent #13ce66;
      content: "";
      position: absolute;
      top: 9px;
      right: -7px;
      margin-top: -10px;
      display: block;
      width: 0px;
      height: 0px;
      z-index: -1;
    }
    .rightContent{
      border-radius: 0px 5px 5px 5px;
      border:1px solid #1990fc;
    }
    .rightContent:before {
      border-style: solid;
      border-width: 0px 6px 6px 0px;
      border-color: transparent #fff transparent transparent ;
      content: "";
      position: absolute;
      top: 9px;
      left: -5px;
      margin-top: -9px;
      display: block;
      width: 0px;
      height: 0px;
      z-index: 0;
    }
    .rightContent:after {
      border-style: solid;
      border-width: 0px 7px 7px 0px;
      border-color: transparent #1990fc transparent transparent;
      content: "";
      position: absolute;
      top: 9px;
      left: -7px;
      margin-top: -10px;
      display: block;
      width: 0px;
      height: 0px;
      z-index: -1;
    }
    .rightRecordBox{
      text-align: right;
    }
  }
  .spaceWarnPop{
    display: inline-block;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    // margin: -120px 0 0 160px;
    right: 30px;
    bottom: 50px;
    max-width: 100%;
  }
  .btnGroup{
    display: flex;
    position: relative;
    background: #fff;
    padding: 10px 0;
    .upload-demo{
      margin-left: 10px;
    }
  }
  .submitNewContent{
    .el-input-group__append,.el-input-group__append div{
      height: 34px;
      img{
        height: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.el-popper{
  .statuSelect{
    display: inline-block;
    line-height: 26px;
    border-radius: 10px;
    cursor: pointer;
    color: #aaadb4;
    border: 1px solid #aaadb4;
    margin-bottom: 10px;
    width: 150px;
  }
  .activeStatu{
    color: #1990fc;
    border: 1px solid #1990fc;
  }
  .statusOption{
    position: relative;
    text-align: center;
  }
  .el-icon-success{
    color: #1990fc;
    position: absolute;
    right: 3px;
    top: -5px;
    background: #fff;
    font-size: 18px;
  }
}
#feedBackDetail{

}
</style>
